// import React, { useEffect } from "react";

// import { useDispatch, useSelector } from "react-redux";
// import { getAttendanceList } from "app/redux/slice/attendanceSlice";

// const Attendance = () => {
//   const dispatch = useDispatch();
//   const attendanceData = useSelector((state) => state?.attendance);
//   console.log("barcode", attendanceData?.barcode);
//   useEffect(() => {
//     dispatch(getAttendanceList());
//   }, []);
//   return <></>;
// };

// export default Attendance;
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getAttendanceList } from "app/redux/slice/attendanceSlice";
import { QRCodeCanvas } from "qrcode.react"; // ✅ Import QRCode component

const Attendance = () => {
  const dispatch = useDispatch();
  const attendanceData = useSelector((state) => state?.attendance);
  const barcodeValue = attendanceData?.barcode || "";
 useEffect(() => {
    dispatch(getAttendanceList());

    const interval = setInterval(() => {
      dispatch(getAttendanceList());
    }, 10000); 

    return () => clearInterval(interval);
  }, [dispatch]);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        marginTop: 50,
      }}
    >
      <h1>Attendance QR Code</h1>

      {barcodeValue ? (
        <QRCodeCanvas
          value={barcodeValue}
          size={250}
          bgColor="#ffffff"
          fgColor="#000000"
          level="Q"
          includeMargin={true}
        />
      ) : (
        <p>No barcode data available</p>
      )}

      {/* <p style={{ marginTop: 10, fontWeight: "bold" }}>{barcodeValue}</p> */}
    </div>
  );
};

export default Attendance;
